(function (root, factory) {
  const api = factory();
  if (typeof module === "object" && module.exports) {
    module.exports = api;
  }
  if (root) {
    root.VendeyPlantillaTicket = api;
  }
})(typeof globalThis !== "undefined" ? globalThis : this, function () {
  "use strict";

  const STORAGE_KEY = "vendeyPlantillaTicketV1";
  const PLANTILLA_DEFAULT = Object.freeze({
    anchoPapelMm: 80,
    fuentePx: 10,
    logoAnchoMm: 24,
    logoDataUrl: "",
    direccionEmpresa: "",
    telefonoEmpresa: "",
    textoEncabezado: "",
    mensajePie: "Gracias por su compra",
    textoPieAdicional: "",
    separador: "dashed",
    mostrarDireccionEmpresa: true,
    mostrarDireccionCliente: true,
    mostrarVendedor: true,
    mostrarPrecioUnitario: true,
    mostrarTributos: true,
    mostrarPagado: true,
    mostrarVuelto: true
  });

  function texto(valor, maximo) {
    return String(valor == null ? "" : valor).trim().slice(0, maximo || 500);
  }

  function numeroEntre(valor, minimo, maximo, defecto) {
    const numero = Number(valor);
    return Number.isFinite(numero)
      ? Math.min(maximo, Math.max(minimo, numero))
      : defecto;
  }

  function booleano(valor, defecto) {
    return typeof valor === "boolean" ? valor : defecto;
  }

  function normalizarPlantilla(valor) {
    const entrada = valor && typeof valor === "object" ? valor : {};
    const ancho = Number(entrada.anchoPapelMm) === 58 ? 58 : 80;
    const separadores = ["dashed", "dotted", "solid"];
    return {
      anchoPapelMm: ancho,
      fuentePx: numeroEntre(
        entrada.fuentePx,
        8,
        14,
        PLANTILLA_DEFAULT.fuentePx
      ),
      logoAnchoMm: numeroEntre(
        entrada.logoAnchoMm,
        12,
        45,
        PLANTILLA_DEFAULT.logoAnchoMm
      ),
      logoDataUrl: /^data:image\/(png|jpe?g|webp);base64,/i.test(
        String(entrada.logoDataUrl || "")
      )
        ? String(entrada.logoDataUrl)
        : "",
      direccionEmpresa: texto(entrada.direccionEmpresa, 240),
      telefonoEmpresa: texto(entrada.telefonoEmpresa, 80),
      textoEncabezado: texto(entrada.textoEncabezado, 180),
      mensajePie:
        texto(entrada.mensajePie, 240) || PLANTILLA_DEFAULT.mensajePie,
      textoPieAdicional: texto(entrada.textoPieAdicional, 300),
      separador: separadores.includes(entrada.separador)
        ? entrada.separador
        : PLANTILLA_DEFAULT.separador,
      mostrarDireccionEmpresa: booleano(
        entrada.mostrarDireccionEmpresa,
        PLANTILLA_DEFAULT.mostrarDireccionEmpresa
      ),
      mostrarDireccionCliente: booleano(
        entrada.mostrarDireccionCliente,
        PLANTILLA_DEFAULT.mostrarDireccionCliente
      ),
      mostrarVendedor: booleano(
        entrada.mostrarVendedor,
        PLANTILLA_DEFAULT.mostrarVendedor
      ),
      mostrarPrecioUnitario: booleano(
        entrada.mostrarPrecioUnitario,
        PLANTILLA_DEFAULT.mostrarPrecioUnitario
      ),
      mostrarTributos: booleano(
        entrada.mostrarTributos,
        PLANTILLA_DEFAULT.mostrarTributos
      ),
      mostrarPagado: booleano(
        entrada.mostrarPagado,
        PLANTILLA_DEFAULT.mostrarPagado
      ),
      mostrarVuelto: booleano(
        entrada.mostrarVuelto,
        PLANTILLA_DEFAULT.mostrarVuelto
      )
    };
  }

  function obtenerPlantilla(storage) {
    try {
      const guardada = storage && storage.getItem(STORAGE_KEY);
      return normalizarPlantilla(guardada ? JSON.parse(guardada) : {});
    } catch (_) {
      return normalizarPlantilla({});
    }
  }

  function guardarPlantilla(valor, storage) {
    const plantilla = normalizarPlantilla(valor);
    if (!storage || typeof storage.setItem !== "function") {
      throw new Error("El almacenamiento local no está disponible.");
    }
    storage.setItem(STORAGE_KEY, JSON.stringify(plantilla));
    return plantilla;
  }

  function limpiarRuc(valor) {
    return texto(valor, 30)
      .replace(/^r\.?\s*u\.?\s*c\.?\s*:?\s*/i, "")
      .trim();
  }

  function tipoDocumentoDesdeSerie(serie) {
    const valor = texto(serie, 80).toUpperCase();
    if (/(^|[^A-Z])F[A-Z0-9]*[-\s]/.test(valor) || valor.startsWith("F")) {
      return "FACTURA ELECTRÓNICA";
    }
    if (/(^|[^A-Z])B[A-Z0-9]*[-\s]/.test(valor) || valor.startsWith("B")) {
      return "BOLETA ELECTRÓNICA";
    }
    return "TICKET DE VENTA";
  }

  function extraerCabecera(columnas, pedido) {
    const cabecera = Array.isArray(columnas) ? columnas : [];
    const venta = pedido && typeof pedido === "object" ? pedido : {};
    const serie = texto(
      venta.comprobantebuscar || venta.ncodigo || venta.comprobante || "",
      80
    );
    return {
      // Contrato de spVNT_FACTURATICKETCSVWEB:
      // posición 3 = razón social y posición 5 = número de RUC.
      razonSocial: texto(cabecera[3], 180),
      ruc: limpiarRuc(cabecera[5]),
      serie,
      tipoDocumento: tipoDocumentoDesdeSerie(serie),
      cliente: texto(cabecera[48] || venta.nombrecliente, 220),
      numeroDocumento: texto(
        cabecera[46] || venta.nrodocumento || venta.documento,
        30
      ),
      direccionCliente: texto(cabecera[70] || venta.direccion, 260),
      fecha: texto(cabecera[6] || venta.fecha, 80),
      vendedor: texto(cabecera[52], 160)
    };
  }

  return {
    STORAGE_KEY,
    PLANTILLA_DEFAULT,
    normalizarPlantilla,
    obtenerPlantilla,
    guardarPlantilla,
    extraerCabecera,
    tipoDocumentoDesdeSerie
  };
});
